import { useCallback, useMemo } from 'react'
import { useTheme } from '@mui/material'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent
} from 'echarts/components'

import { TrialYearStats } from 'features/trial/types'

echarts.use([
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer
])

type TrialBarGraphProps = {
  yearsStats: TrialYearStats
  selectedYear: number | null
  setSelectedYear: (year: number | null) => void
  height?: number | undefined
}
export const TrialBarGraph = ({
  yearsStats,
  selectedYear,
  setSelectedYear,
  height
}: TrialBarGraphProps) => {
  const theme = useTheme()
  const selectedItemStyle = useMemo(
    () => ({
      color: theme.palette.primary.main
    }),
    [theme]
  )
  const unSelectedItemStyle = useMemo(
    () => ({
      color: theme.palette.action.disabled
    }),
    [theme]
  )
  const onClickGraph = useCallback(
    (params?: {
      dataIndex?: number
    }) => {
      if (params?.dataIndex !== undefined) {
        const year = yearsStats.list[params.dataIndex]?.year
        if (year) {
          setSelectedYear(selectedYear === year ? null : year)
        }
      }
    },
    [selectedYear, setSelectedYear, yearsStats]
  )
  return (yearsStats.maxCount > 0) ? (
    <ReactEChartsCore
      echarts={echarts}
      notMerge={true}
      onEvents={{
        click: onClickGraph
      }}
      option={{
        //animation: false,
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          show: true,
          data: yearsStats.list.map(r => `${r.year}年`),
          axisLabel: {
            interval: 0,
            fontSize: 10
          },
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          show: false,
          interval: 0,
          min: 0,
          max: yearsStats.maxCount
        },
        series: [{
          type: 'bar',
          name: 'trialCountByYear',
          showBackground: true,
          barGap: 0,
          large: true,
          barWidth: '95%',
          backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)'
          },
          label: {
            show: true,
            formatter: '{c}件'
          },
          data: yearsStats.list.map(r => ({
            key: r.year,
            value: r.count,
            itemStyle: (
              selectedYear === null ? undefined :
              r.year === selectedYear ? selectedItemStyle :
              unSelectedItemStyle
            )
          }))
        }]
      }}
      opts={{
        renderer: 'svg',
        width: 'auto'
      }}
      style={{
        height
      }}
      theme="insite"
    />
  ) : <></>
}
